import React, { useState, useEffect } from "react";
import { ReactComponent as Compose } from "../assets/svgs/compose.svg";
import DashboardMessage from "../components/molecules/DashboardManagement";
import {
  getSDG,
  getHighestAmountCredits,
  getTopCreditsInDemand
} from "../utils/api/dashboardManagement";
import { Skeleton } from "antd";
import { useNavigate } from "react-router-dom";

const Dashboard = ({ logout }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedCompose, setSelectedCompose] = useState(null);
  const navigate = useNavigate();
  const [sdgData, setSdgData] = useState([]);
  const [creditsData, setCreditsData] = useState([]);
  const [demandData, setDemandData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [demandLoading, setDemandLoading] = useState(true);
  const [error, setError] = useState(null);
  const [demandError, setDemandError] = useState(null);
  const [sdgDataRange, setSdgDataRange] = useState("");
const [creditsDataRange, setCreditsDataRange] = useState("");
const [demandDataRange, setDemandDataRange] = useState("");

  const fetchData = async () => {
    setLoading(true);
    setDemandLoading(true);
    try {
      const [sdgResponse, creditsResponse, demandResponse] = await Promise.all([
        getSDG(logout),
        getHighestAmountCredits(logout),
        getTopCreditsInDemand(logout)
      ]);
      setSdgData(sdgResponse[0].sdg);
      setCreditsData(creditsResponse[0].credits);
      setDemandData(demandResponse[0].credits);

      setSdgDataRange(sdgResponse[0].data_range);
      setCreditsDataRange(creditsResponse[0].data_range);
      setDemandDataRange(demandResponse[0].data_range);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
      setDemandLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [logout]);

  const handleDialogClose = () => {
    setIsDialogOpen(false);
    navigate(`/setting/dashboard`);
  };

  const handleComposeClick = (section) => {
    setSelectedCompose(section);
    setIsDialogOpen(true);
  };

  const refreshData = () => {
    fetchData();
  };

  return (
    <div className="h-full w-full p-6 flex flex-col">
      <div className="flex-1 pt-3 gap-y-4 bg-white rounded-3xl shadow-formShadow pb-3">
        {/* SDG Section */}
        <div className="flex items-center">
          <div
            className="cursor-pointer flex items-center gap-x-2 p-4 "
            onClick={() => handleComposeClick("sdg")}
          >
            <span className="text-lg font-medium">Sdg in Demand</span>
            <Compose className="w-6 h-6 text-blue-500" />
          </div>
        </div>
        <div className="mt-5">
          {loading ? (
            <div className="flex flex-col gap-y-4 p-4">
              <Skeleton.Button block={true} active={true} />
              <Skeleton.Button block={true} active={true} />
              <Skeleton.Button block={true} active={true} />
              <Skeleton.Button block={true} active={true} />
            </div>
          ) : error ? (
            <p className="pl-10 text-red-500">Error: {error}</p>
          ) : (
            sdgData.map((credit, index) => (
              <li
                key={credit._id}
                className={
                  "py-1 pl-10 flex " +
                  (index % 2 === 0 ? "bg-blue-100" : "bg-white")
                }
              >
                <span className="text-[14px]">{index + 1} .</span>
                <span
                  className={
                    "ml-5 " +
                    (index === 0 ? "text-14 font-bold" : "text-12 font-medium")
                  }
                >
                  {credit.name}
                </span>
              </li>
            ))
          )}
        </div>

        {/* Top 5 Credits - Highest Amount First Section */}
        <div className="flex items-center">
          <div
            className="cursor-pointer flex items-center gap-x-2 p-4 "
            onClick={() => handleComposeClick("amount")}
          >
            <span className="text-lg font-medium">
              Top 5 Credits - Highest amount first
            </span>
            <Compose className="w-6 h-6 text-blue-500" />
          </div>
        </div>
        <div className="mt-5">
          {loading ? (
            <div className="flex flex-col gap-y-4 p-4">
              <Skeleton.Button block={true} active={true} />
              <Skeleton.Button block={true} active={true} />
              <Skeleton.Button block={true} active={true} />
              <Skeleton.Button block={true} active={true} />
            </div>
          ) : error ? (
            <p className="pl-10 text-red-500">Error: {error}</p>
          ) : (
            creditsData.map((credit, index) => (
              <li
                key={credit._id}
                className={
                  "py-1 pl-10 flex " +
                  (index % 2 === 0 ? "bg-blue-100" : "bg-white")
                }
              >
                <span className="text-[14px]">{index + 1} .</span>
                <span
                  className={
                    "ml-5 " +
                    (index === 0 ? "text-14 font-bold" : "text-12 font-medium")
                  }
                >
                  {credit.name}
                </span>
              </li>
            ))
          )}
        </div>

        {/* Top 5 Credits - In Demand Section */}
        <div className="mt-4">
          <div className="flex items-center">
            <div
              className="cursor-pointer flex items-center gap-x-2 p-4 "
              onClick={() => handleComposeClick("demand")}
            >
              <span className="text-lg font-medium">
                Top 5 Credits - In Demand
              </span>
              <Compose className="w-6 h-6 text-blue-500" />
            </div>
          </div>
          <div className="mt-5">
            {demandLoading ? (
              <div className="flex flex-col gap-y-4 p-4">
                <Skeleton.Button block={true} active={true} />
                <Skeleton.Button block={true} active={true} />
                <Skeleton.Button block={true} active={true} />
                <Skeleton.Button block={true} active={true} />
              </div>
            ) : demandError ? (
              <p className="pl-10 text-red-500">Error: {demandError}</p>
            ) : (
              demandData.map((credit, index) => (
                <li
                  key={credit._id}
                  className={
                    "py-1 pl-10 flex " +
                    (index % 2 === 0 ? "bg-blue-100" : "bg-white")
                  }
                >
                  <span className="text-[14px]">{index + 1} .</span>
                  <span
                    className={
                      "ml-5 " +
                      (index === 0
                        ? "text-14 font-bold"
                        : "text-12 font-medium")
                    }
                  >
                    {credit.name}
                  </span>
                </li>
              ))
            )}
          </div>
        </div>
      </div>
      <DashboardMessage
        open={isDialogOpen}
        onOk={() => {
          handleDialogClose();
          refreshData(); 
        }}
        onCancel={handleDialogClose}
        creditsData={selectedCompose === "amount" ? creditsData : []}
        demandData={selectedCompose === "demand" ? demandData : []}
        sdgData={selectedCompose === "sdg" ? sdgData : []}
        sdgDataRange={selectedCompose === "sdg" ? sdgDataRange : ""}
        creditsDataRange={selectedCompose === "amount" ? creditsDataRange : ""}
        demandDataRange={selectedCompose === "demand" ? demandDataRange : ""}
      />
    </div>
  );
};

export default Dashboard;